<template>
  <div data-html2canvas-ignore @click="screenShot" class="submit">
    {{ submitBtn }}
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import { Toast } from 'vant'
import { uploadToAliyunOss } from '../service'

export default {
  name: 'ScreenAndSubmit',
  props: {
    signImgSrc: String,
    page: String,
    userInputData: Object
  },
  data() {
    return {
      submitBtn: this.$t('common.submit')
    }
  },
  methods: {
    uploadFile: uploadToAliyunOss().uploadFile,
    // 页面元素转图片
    async screenShot() {
      if (!this.signImgSrc) {
        Toast({
          message: this.$t('signing.fieldEmptyToast')
        })
        return
      } else if (this.page === 'contractImg' && Object.values(this.userInputData).some((val) => !val)) {
        Toast({
          message: this.$t('signing.fieldEmptyToast')
        })
        return
      }

      await this.$emit('showInputFun', false)
      this.submitBtn = 'Submitting'

      const element = document.getElementsByClassName('sign_container')[0]
      const scrollHeight = element.scrollHeight
      const originalHeight = element.style.height

      // 临时设置容器高度为完整滚动高度
      element.style.height = scrollHeight + 'px'
      await this.$nextTick();

      html2canvas(element, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        height: scrollHeight,
        windowHeight: scrollHeight
      })
        .then((canvas) => {
          element.style.height = originalHeight
          let dataURL = canvas.toDataURL('image/png')
          const file = this.base64toFile(dataURL)

          this.uploadFile(file,
            (res) => {
              sessionStorage.setItem(this.page, res.url)
              this.$router.back()
              this.$emit('showInputFun', true)
            }
          )
        })
        .catch(function (error) {
          console.error('error', error)
        })
    },
    // base64转file二进制
    base64toFile(dataurl, filename = 'file') {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let suffix = mime.split('/')[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime
      })
    }
  }
}
</script>

<style scoped>
.submit {
  width: 3.38rem;
  height: 0.5rem;
  line-height: 0.5rem;
  background: #378e5b;
  border-radius: 0.37rem;
  font-size: 0.16rem;
  color: #fff;
  font-weight: 600;
  position: fixed;
  bottom: 0.2rem;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/ScreenAndSubmit.vue